// extracted by mini-css-extract-plugin
module.exports = {"selectedFilters":"styles_selectedFilters__Zp3Zo","label":"styles_label__25jEy","filtersWrapper":"styles_filtersWrapper__22bIH"};